import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import Select from "react-select";
import { withGenericConfig } from "/contexts/generic-config-context";
import { componentStyles } from "./multi-select-input.scss";
import { commonInputStyles } from "../common-inputs.scss";
import { Option, MultiValueRemove, ClearIndicator, DropdownIndicator } from "./multi-select-custom-components";
import getReactSelectStyles from "./multi-select-styles";
// react-select docs: https://react-select.com/home
function MultiSelectInput(props) {
    const { inputData, onInputChange, onInputBlur, value, invalid, errorLabelId, id, translate } = props;
    const { inputName, isRequired, options, defaultValue, isMulti, placeholder } = inputData;
    const getTranslatedOptions = ()=>{
        return options.map((option)=>{
            return {
                label: translate(option.label),
                value: option.value
            };
        });
    };
    const getTranslatedPlaceholder = ()=>{
        return translate(placeholder);
    };
    const onBlur = ()=>{
        // we change the data from react-select to be the same as the data from the other inputs
        onInputBlur({
            target: {
                name: inputName,
                value: value !== null && value !== void 0 ? value : ""
            }
        });
    };
    const onChange = (newValue, action)=>{
        // we change the data from react-select to be the same as the data from the other inputs
        onInputChange({
            target: {
                name: action.name,
                value: newValue
            }
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Select, {
                className: "hp-multi-select-input",
                classNamePrefix: "react-select",
                id: id,
                name: inputName,
                onChange: onChange,
                onBlur: onBlur,
                defaultValue: defaultValue,
                options: getTranslatedOptions(),
                placeholder: getTranslatedPlaceholder(),
                components: {
                    Option,
                    MultiValueRemove,
                    ClearIndicator,
                    DropdownIndicator
                },
                isMulti: isMulti,
                hideSelectedOptions: false,
                styles: getReactSelectStyles(invalid),
                required: isRequired,
                "aria-required": isRequired,
                "aria-invalid": invalid,
                "aria-describedby": errorLabelId,
                isSearchable: false,
                closeMenuOnSelect: false,
                blurInputOnSelect: false
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: componentStyles.__hash,
                children: componentStyles
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: commonInputStyles.__hash,
                children: commonInputStyles
            })
        ]
    });
}
export default withGenericConfig(MultiSelectInput);
